<template>
  <div>
    <Spinner v-if="isLoading" />

    <div class="notification is-info" v-if="hasNoHunts">No hunts found.</div>

    <div class="notification is-danger" v-if="loadError">{{ loadError }}</div>

    <HuntsList
      :userId="user.id"
      :hunts="hunts"
      :usersCacheStorePath="usersCacheStorePath"
      v-if="huntsLoaded"
      @hunt-selected="huntSelected($event)"/>
  </div>
</template>

<script>
import Spinner from "@/components/utils/Spinner";
import HuntsList from "@/modules/hunts/HuntsList";

import {
  GET_USER,
  LOAD_HUNTS,
  IS_LOADING_HUNTS,
  GET_HUNTS,
  HAS_EMPTY_HUNTS_LOAD_RESULT,
  GET_HUNTS_LOAD_ERROR
} from "./userStore";

import {
  SET_HUNT
} from "@/modules/hunts/huntStore.js"

export default {
  name: "UserHuntsTab",

  components: {
    HuntsList,
    Spinner
  },

  props: {
    userStorePath: {
      type: String,
      required: true
    },

    selectedHuntStorePath: {
      type: String,
      required: true
    },

    usersCacheStorePath: {
      type: String,
      required: true
    }
  },

  mounted() {
    const loadHuntsAction = `${this.userStorePath}/${LOAD_HUNTS}`;
    this.$store.dispatch(loadHuntsAction);
  },

  computed: {
    huntsLoaded() {
      return this.user !== null && this.hunts !== null;
    },

    user() {
      const getUser = `${this.userStorePath}/${GET_USER}`;
      return this.$store.getters[getUser];
    },

    isLoading() {
      const isLoadingHunts = `${this.userStorePath}/${IS_LOADING_HUNTS}`;
      return this.$store.getters[isLoadingHunts];
    },

    hasNoHunts() {
      const hasEmptyHuntsLoadResult = `${this.userStorePath}/${HAS_EMPTY_HUNTS_LOAD_RESULT}`;
      return this.$store.getters[hasEmptyHuntsLoadResult];
    },

    hunts() {
      const getHunts = `${this.userStorePath}/${GET_HUNTS}`;
      return this.$store.getters[getHunts];
    },

    loadError() {
      const getHuntsLoadError = `${this.userStorePath}/${GET_HUNTS_LOAD_ERROR}`;
      return this.$store.getters[getHuntsLoadError];
    }
  },

  methods: {
    huntSelected(hunt) {
      const setHuntAction = `${this.selectedHuntStorePath}/${SET_HUNT}`;
      this.$store.dispatch(setHuntAction, { hunt });

      const huntId = hunt.id;
      this.$router.push({ name: 'userDetailsHunt', params: { huntId }, query: this.$route.query });
    }
  }
};
</script>
